import React from 'react';
import { useTranslation } from 'react-i18next';
import './StyleInput.scss';
import OverlayStyleFullScreenIcon from '../../../images/overlay-style-fullscreen-icon.png';
import OverlayStyleLetterBoxIcon from '../../../images/overlay-style-letterbox-icon.png';
import ToggleButton from '../../ProducerComponents/ProducerControlPanel/Widgets/ToggleButton';
import useProject from '../../../hooks/useProject';
import { OverlayStyleEnum } from '../../../types/enums/OverlayStyleEnum';
import Help from '../../Help/Help';

const StyleInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();

  const onChange = (value: string | number | boolean) => {
    if (project?.stream?.sourceLanguageIsoCode === project?.encoder?.languageIsoCode) {
      updateStream({
        overlayStyle: value,
      });
    } else {
      updateEncoder(project.encoder, {
        overlayStyle: value,
      });
    }
  };

  return (
    <div className="style-input">
      <div className="input-title">
        {t('producer.inputs.style.title')}
        <Help
          title="Overlay Style"
          text="Overlay Style determines how captions appear on your video.<br/><br/>- <b>Full Screen:</b> Overlaid as a black box flush with the player.<br/>- <b>Letter Box:</b> : Captions can be displayed floating letterbox size which can be full adjusted and moved on the screen."
        />
        </div>
      <ToggleButton
        leftValue={OverlayStyleEnum.FullScreen}
        leftImage={OverlayStyleFullScreenIcon}
        leftButtonClassName={`${
          project.encoder.overlayStyle === OverlayStyleEnum.FullScreen
            ? 'control-panel-button-selected-button'
            : null
        }`}
        rightValue={OverlayStyleEnum.Letterbox}
        rightImage={OverlayStyleLetterBoxIcon}
        rightButtonClassName={`${
          project.encoder.overlayStyle === OverlayStyleEnum.Letterbox
            ? 'control-panel-button-selected-button'
            : null
        }`}
        isReadOnly={false}
        footerText={t('producer.inputs.style.footer')}
        onSelection={onChange}
        leftAccessibilityName={t('producer.inputs.style.accessibility.fullscreen')}
        rightAccessibilityName={t('producer.inputs.style.accessibility.letterbox')}
      />
    </div>
  );
};

export default React.memo(StyleInput);
